import React from "react";
import CKEditorForm from "../../pages/CkEditor/CKEditorForm";
import CorporateMembers from "../../pages/corporateMembers/CorporateMembers";
import ViewCorporateMembersDetailForm from "../../features/ViewCorporateMembersDetailForm/ViewCorporateMembersDetailForm";
import MembershipApplicationList from "../../pages/membershipApplicationList";
import MemberApplicationTaskListDetail from "../../pages/memberapplicationtasklistdetailform";
import BoardApprovalUpdatePage from "../../pages/BoardApprovalUpdate";
import BoardApprovalAssignmentPage from "../../pages/BoardApprovalAssignment";
import BoardMemberManagementPage from "../../pages/BoardMemberManagement";
import XeroPaymentUpdatePage from "../../pages/XeroPaymentUpdate";
import ViewResourcesPage from "../../pages/ViewResources";
import CreateResourcesPage from "../../pages/CreateResources";
import KeyPositionRequestPage from "../../pages/KeyPositionRequest";
import ViewChangeKeyPositionPage from "../../pages/ViewChangeKeyPosition";
import ViewAccountTaskList from "../../pages/AccountManagement/viewEditAccount";
import AccountManagement from "../../pages/AccountManagement/createAccount";
import CorporatePricingTable from "../../pages/gmap/corporatePricingTable/CorporatePricingTable";
import EmailTemplateManagement from "../../pages/fieldMaintenance/emailTemplateManagement/index";
import EditEmailTemplate from "../../features/FieldManagement/EmailTempManagement/EditEmailTemp";

// import Analytics from "../../features/Analytics/analytics";
import AddNewEmailTemplate from "../../features/FieldManagement/EmailTempManagement/AddNewEmailTemplate";
import ViewChangeKeyPositionCertificateCoordinator from "../../pages/ViewChangeKeyPositionCertificateCoordinator";
import DropdownManagement from "../../pages/fieldMaintenance/dropdownManagement/DropdownManagement";
import ViewResourceDetails from "../../pages/ViewResourceDetails";
import ViewSGBSApplicationForm from "../../pages/ViewSGBSApplicationForm";
import ViewSGBPApplicationForm from "../../pages/ViewSGBPApplicationForm";
import ViewApplicationTaskList from "../../pages/viewApplicationTaskList";
import CRUDCategory from "../../pages/crudCategory";
import CRUDRequirement from "../../pages/crudRequirement";
import AddRequirementPage from "../../pages/addRequirement";
import CRUDCriteria from "../../pages/crudCriteria";
import AddCriteriaPage from "../../pages/addCriteria";
import ApproveCriteriaPage from "../../pages/approveCriteria";
import SGBPCategory from "../../pages/SGBPCategory";
import SGBSCategory from "../../pages/SGBSCategory";
import AddSGBSCategory from "../../features/SGBSCategoryList/addSGBSCategory/AddSGBSCategory";
import ApproveSGBPCategoryPage from "../../pages/SGBPCategory/ApproveSGBPCategory";
import CaseOfficerEvaluation from "../../pages/CaseOfficerEvaluation";
import PeerReviewerEvaluationApproval from "../../pages/PeerReviewerEvaluationApproval";
import EditCRUDRequirement from "../../pages/editRequirement";

import BatchCertPage from "../../pages/BatchCert";
import EditCriteriaPage from "../../pages/EditCriteria";
import DuplicateCriteriaForm from "../../pages/duplicateCriteria";
import AddSGBPCategory from "../../features/CategoryCriteriaCertificateMapping/Component/addSGBPCategory/AddSGBPCategory";
import EditSGBPCategory from "../../features/CategoryCriteriaCertificateMapping/Component/editSGBPCategory/EditSGBPCategory";
import RequirementApprovalList from "../../features/RequirementApproval/RequirementApprovalList";
import ApproveRequirementForm from "../../features/RequirementApproval/Component/ApproveRequirement/ApproveRequirement";
import CriteriaApproval from "../../pages/CriteriaApproval";
import ApproveCategory from "../../features/ApproveCategoryCriteriaMapping/ViewApproveCategoryCriteria/ViewApproveCategoryCritreia";
import InvoiceApproval from "../../pages/InvoiceApproval";
import GenerateInvoice from "../../pages/GenerateInvoice";
import CertificateGrouping from "../../pages/CertificateGrouping";
import XeroPaymentUpdateListPage from "../../pages/XeroPaymentUpdateList";
import CertificateIssuancePage from "../../pages/CertificateIssuance";
import CertificateGroupingApprove from "../../pages/CertificateGroupingApprove";
import CertificateGroupingRequest from "../../pages/CertificateGroupingRequest";
import CertificateCorporateListPage from "../../pages/CertificateCorporateListPage/certificateCorporateListPage";
import ViewCertificateCorporateAccountPage from "../../pages/ViewCertificateCorporateAccountPage/ViewCertificateCorporateAccountPage";
import ProductsApplication from "../../pages/productsApplication/ProductsApplication";
import ServiceApplication from "../../pages/serviceApplication/ServiceApplication";
import CorporateMembershipReport from "../../pages/metabaseDashboard/CorporateMembershipReport";
import MembershipAnalyticsByMonth from "../../pages/metabaseDashboard/MembershipAnalyticsByMonth";
import MemberOrganisationCategory from "../../pages/metabaseDashboard/MemberOrganisationCategory";
import MembershipAnalyticsByYear from "../../pages/metabaseDashboard/MembershipAnalyticsByYearReport";
import RenewalAnalyticsReport from "../../pages/metabaseDashboard/RenewalAnalyticsReport";
import MembershipRetentionRateReport from "../../pages/metabaseDashboard/MembershipRetentionRateReport";
import MembershipGrowthChart from "../../pages/metabaseDashboard/MembershipGrowthChart";
import MembershipRetentionRateChart from "../../pages/metabaseDashboard/MembershipRetentionRateChart";

const NotFound = React.lazy(() => import("../../pages/errors/NotFound"));
const Dashboard = React.lazy(() => import("../../pages/dashboard/Dashboard"));
const admin = "1";
const lead = "10";
const support = "11";

export const ComponentNavigation = [
  {
    id: "dashboard",
    path: "/",
    exact: true,
    title: "Membership Overview",
    component: Dashboard,
    hasParams: false,
    text: "Membership Overview",
    securityKey: [admin, lead, support],
  },
  {
    id: "corporatePricingTable",
    path: "/corporatePricingTable",
    exact: true,
    title: "Membership Pricing Table",
    component: CorporatePricingTable,
    hasParams: false,
    text: "Membership Pricing Table",
    securityKey: [admin, lead],
  },
  {
    id: "membershipApplicationList",
    path: "/membershipApplicationList",
    exact: true,
    title: "Application",
    component: MembershipApplicationList,
    hasParams: false,
    text: "Application",
    securityKey: [admin, lead, support],
  },
  {
    id: "CertificateCorporateListPage",
    path: "/CertificateCorporateListPage",
    exact: true,
    title: "Certificate Corporate List",
    component: CertificateCorporateListPage,
    hasParams: false,
    text: "Certificate Corporate List",
    securityKey: [admin, lead, support],
  },
  {
    id: "viewCertificateCorporateAccountPage",
    path: "/viewCertificateCorporateAccountPage",
    exact: true,
    title: "View Certificate Corporate Account",
    component: ViewCertificateCorporateAccountPage,
    hasParams: false,
    text: "View Certificate Corporate Account",
    securityKey: [admin, lead, support],
  },
  {
    id: "productsApplication",
    path: "/productsApplication",
    exact: true,
    title: "Products Application Details",
    component: ProductsApplication,
    hasParams: false,
    text: "Products Application Details",
    securityKey: [admin, lead, support],
  },
  {
    id: "serviceApplication",
    path: "/serviceApplication",
    exact: true,
    title: "Service Application Details",
    component: ServiceApplication,
    hasParams: false,
    text: "Service Application Details",
    securityKey: [admin, lead, support],
  },
  {
    id: "memberapplicationtasklistdetailform",
    path: "/memberapplicationtasklistdetailform/:id/:id2",
    exact: true,
    title: "Application - Details",
    component: MemberApplicationTaskListDetail,
    hasParams: false,
    text: "Application - Details",
    securityKey: [admin, lead, support],
  },
  {
    id: "corporateMembers",
    path: "/corporateMembers",
    exact: true,
    title: "Database",
    component: CorporateMembers,
    hasParams: false,
    text: "Database",
    securityKey: [admin, lead, support],
  },
  {
    id: "viewCorporateMember",
    path: "/viewCorporateMember/:id",
    exact: true,
    title: "Database",
    component: ViewCorporateMembersDetailForm,
    hasParams: false,
    text: "Database",
    securityKey: [admin, lead, support],
  },
  {
    id: "ckEditorTest",
    path: "/ckEditorTest",
    exact: true,
    title: "CK Classic Editor Test",
    component: CKEditorForm,
    hasParams: false,
    text: "CK Classic Editor Test",
    securityKey: [admin, lead, support],
  },
  {
    id: "pageNotFound",
    path: "pageNotFound",
    exact: true,
    title: "",
    component: NotFound,
    text: "Page not found",
    securityKey: [admin, lead, support],
  },
  {
    id: "boardApprovalUpdate",
    path: "/boardApprovalUpdate",
    exact: true,
    title: "Task List",
    component: BoardApprovalUpdatePage,
    hasParams: false,
    text: "Task List",
    securityKey: [admin, lead],
  },
  {
    id: "boardApprovalAssignment",
    path: "/boardApprovalAssignment",
    exact: true,
    title: "Submission for Board Approval",
    component: BoardApprovalAssignmentPage,
    hasParams: false,
    text: "Submission for Board Approval",
    securityKey: [admin, lead],
  },
  {
    id: "boardMemberManagement",
    path: "/boardMemberManagement",
    exact: true,
    title: "Board Member Management",
    component: BoardMemberManagementPage,
    hasParams: false,
    text: "Board Member Management",
    securityKey: [admin, lead],
  },
  {
    id: "xeroPaymentUpdate",
    path: "/xeroPaymentUpdate",
    exact: true,
    title: "Payment Status",
    component: XeroPaymentUpdatePage,
    hasParams: false,
    text: "Payment Status",
    securityKey: [admin, lead, support],
  },
  {
    id: "viewResources",
    path: "/viewResources",
    exact: true,
    title: "Member Resources",
    component: ViewResourcesPage,
    hasParams: false,
    text: "Member Resources",
    securityKey: [admin, lead, support],
  },
  {
    id: "createResources",
    path: "/createResources",
    exact: true,
    title: "Create Resources",
    component: CreateResourcesPage,
    hasParams: false,
    text: "Create Resources",
    securityKey: [admin, lead, support],
  },
  {
    id: "ViewResourceDetails",
    path: "/ViewResourceDetails/:id",
    exact: true,
    title: "Resource Details",
    component: ViewResourceDetails,
    hasParams: false,
    text: "Resource Details",
    securityKey: [admin, lead, support],
  },
  {
    id: "keyPositionRequest",
    path: "/keyPositionRequest/:id/:changeId",
    exact: true,
    title: "Key Position Request",
    component: KeyPositionRequestPage,
    hasParams: false,
    text: "Key Position Request",
    securityKey: [admin, lead, support],
  },
  {
    id: "viewChangeKeyPosition",
    path: "/viewChangeKeyPosition",
    exact: true,
    title: "View Change Key Position",
    component: ViewChangeKeyPositionPage,
    hasParams: false,
    text: "View Change Key Position",
    securityKey: [admin, lead, support],
  },
  {
    id: "ViewChangeKeyPositionCertificateCoordinator",
    path: "/ViewChangeKeyPositionCertificateCoordinator",
    exact: true,
    title: "View Change Key Position Certificate Co-ordinator",
    component: ViewChangeKeyPositionCertificateCoordinator,
    hasParams: false,
    text: "View Change Key Position Certificate Co-ordinator",
    securityKey: [admin, lead, support],
  },

  {
    id: "viewSGBSApplicationForm",
    path: "/ViewSGBSApplicationForm/:id",
    exact: true,
    title: "View SGBS Application Form",
    component: ViewSGBSApplicationForm,
    hasParams: false,
    text: "View SGBS Application Form",
    securityKey: [admin, lead, support],
  },

  {
    id: "viewSGBPApplicationForm",
    path: "/viewSGBPApplicationForm/:id",
    exact: true,
    title: "View SGBP Application Form",
    component: ViewSGBPApplicationForm,
    hasParams: false,
    text: "View SGBP Application Form",
    securityKey: [admin, lead, support],
  },
  {
    id: "viewApplicationTaskList",
    path: "/viewApplicationTaskList",
    exact: true,
    title: "Application Task List",
    component: ViewApplicationTaskList,
    hasParams: false,
    text: "Application Task List",
    securityKey: [admin, lead, support],
  },
  {
    id: "createAccount",
    path: "/createAccount",
    exact: true,
    title: "Create Account",
    component: AccountManagement,
    hasParams: false,
    text: "Create Account",
    securityKey: [admin],
  },
  {
    id: "viewEditAccount",
    path: "/viewEditAccount",
    exact: true,
    title: "View/Edit Account",
    component: ViewAccountTaskList,
    hasParams: false,
    text: "View/Edit Account",
    securityKey: [admin],
  },

  {
    id: "emailTemplateManagement",
    path: "/emailTemplateManagement",
    exact: true,
    title: "Email Templates",
    component: EmailTemplateManagement,
    hasParams: false,
    text: "Email Templates",
    securityKey: [admin, lead],
  },
  {
    id: "addEmailTemplate",
    path: "/emailTemplateManagement/addEmailTemplate",
    exact: true,
    title: "Add Email Template",
    component: AddNewEmailTemplate,
    hasParams: false,
    text: "Add Email Template",
    securityKey: [admin, lead],
  },
  {
    id: "editEmailTemplateManagement",
    path: "/emailTemplateManagement/:id",
    exact: true,
    title: "Email Template Management",
    component: EditEmailTemplate,
    hasParams: false,
    text: "Edit Email Template Management",
    securityKey: [admin, lead],
  },
  // {
  //   id: "analytics",
  //   path: "/analytics",
  //   exact: true,
  //   title: "Analytics",
  //   component: Analytics,
  //   hasParams: false,
  //   text: "Analytics",
  //   securityKey: [admin, lead],
  // },
  {
    id: "dropdownManagement",
    path: "/dropdownManagement",
    exact: true,
    title: "Dropdown Management",
    component: DropdownManagement,
    hasParams: false,
    text: "Dropdown Management",
    securityKey: [admin, lead],
  },

  {
    id: "crudCategory",
    path: "/crudCategory",
    exact: true,
    title: "View Categories",
    component: CRUDCategory,
    hasParams: false,
    text: "View Categories",
    securityKey: [admin],
  },
  {
    id: "crudRequirement",
    path: "/crudRequirement",
    exact: true,
    title: "View Requirements",
    component: CRUDRequirement,
    hasParams: false,
    text: "View Requirements",
    securityKey: [admin],
  },
  {
    id: "addRequirement",
    path: "/addRequirement",
    exact: true,
    title: "Add Requirement",
    component: AddRequirementPage,
    hasParams: false,
    text: "Add Requirement",
    securityKey: [admin],
  },
  {
    id: "editCrudRequirement",
    path: "/editCrudRequirement/:id",
    exact: true,
    title: "Edit Requirement",
    component: EditCRUDRequirement,
    hasParams: false,
    text: "Edit Requirement",
    securityKey: [admin],
  },
  {
    id: "approveRequirement",
    path: "/approveRequirement/:id",
    exact: true,
    title: "Approve Requirement",
    component: ApproveRequirementForm,
    hasParams: false,
    text: "Approve Requirement",
    securityKey: [admin],
  },
  {
    id: "crudCriteria",
    path: "/crudCriteria",
    exact: true,
    title: "View Criterias",
    component: CRUDCriteria,
    hasParams: false,
    text: "View Criterias",
    securityKey: [admin],
  },
  {
    id: "addCriteria",
    path: "/addCriteria",
    exact: true,
    title: "Add Criteria",
    component: AddCriteriaPage,
    hasParams: false,
    text: "Add Criteria",
    securityKey: [admin],
  },
  {
    id: "editCriteria",
    path: "/editCriteria/:id",
    exact: true,
    title: "Edit Criteria",
    component: EditCriteriaPage,
    hasParams: false,
    text: "Edit Criteria",
    securityKey: [admin],
  },
  {
    id: "duplicateCriteria",
    path: "/duplicateCriteria/:id",
    exact: true,
    title: "Duplicate Criteria",
    component: DuplicateCriteriaForm,
    hasParams: false,
    text: "Duplicate Criteria",
    securityKey: [admin],
  },
  {
    id: "approveCriteria",
    path: "/approveCriteria/:id",
    exact: true,
    title: "Approve Criterias",
    component: ApproveCriteriaPage,
    hasParams: false,
    text: "Approve Criterias",
    securityKey: [admin],
  },
  {
    id: "SGBPCategory",
    path: "/SGBPCategory",
    exact: true,
    title: "View Criteria Mapping",
    component: SGBPCategory,
    hasParams: false,
    text: "View Criteria Mapping",
    securityKey: [admin],
  },
  {
    id: "AddSGBPCategory",
    path: "/AddSGBPCategory",
    exact: true,
    title: "Category - Criteria - Certificate Mapping",
    component: AddSGBPCategory,
    hasParams: false,
    text: "Add Category - Criteria - Certificate Mapping",
    securityKey: [admin],
  },
  {
    id: "editSGBPCategory",
    path: "/editSGBPCategory/:id",
    exact: true,
    title: "Edit Category - Criteria - Certificate Mapping",
    component: EditSGBPCategory,
    hasParams: false,
    text: "Edit Category - Criteria - Certificate Mapping",
    securityKey: [admin],
  },
  {
    id: "approveCategory",
    path: "/approveCategory/:id",
    exact: true,
    title: "SGBS Category - Criteria Mapping",
    component: ApproveCategory,
    hasParams: false,
    text: "SGBS Category - Criteria Mapping",
    securityKey: [admin],
  },
  {
    id: "ApproveSGBPCategory",
    path: "/ApproveSGBPCategory",
    exact: true,
    title: "Approve Criteria Mapping",
    component: ApproveSGBPCategoryPage,
    hasParams: false,
    text: "Approve Criteria Mapping",
    securityKey: [admin],
  },
  {
    id: "SGBSCategory",
    path: "/SGBSCategory",
    exact: true,
    title: "SGBS Category - Criteria Mapping Listing",
    component: SGBSCategory,
    hasParams: false,
    text: "SGBS Category - Criteria Mapping Listing",
    securityKey: [admin],
  },
  {
    id: "AddSGBSCategory",
    path: "/AddSGBSCategory",
    exact: true,
    title: "SGBS - Criteria Mapping",
    component: AddSGBSCategory,
    hasParams: false,
    text: "Add SGBS Category - Criteria Mapping Listing",
    securityKey: [admin],
  },
  {
    id: "CriteriaApproval",
    path: "/criteriaApproval",
    exact: true,
    title: "Approve Criterias",
    component: CriteriaApproval,
    hasParams: false,
    text: "Approve Criterias",
    securityKey: [admin],
  },
  {
    id: "requirementApproval",
    path: "/requirementApproval",
    exact: true,
    title: "Approve Requirements",
    component: RequirementApprovalList,
    hasParams: false,
    text: "Approve Requirements",
    securityKey: [admin],
  },
  {
    id: "caseOfficerEvaluation",
    path: "/CaseOfficerEvaluation",
    exact: true,
    title: "Case Officer Evaluation Form",
    component: CaseOfficerEvaluation,
    hasParams: false,
    text: "Case Officer Evaluation Form",
    securityKey: [admin],
  },
  {
    id: "PeerReviewerEvaluationApproval",
    path: "/PeerReviewerEvaluationApproval",
    exact: true,
    title: "Peer Reviewer Evaluation Approval ",
    component: PeerReviewerEvaluationApproval,
    hasParams: false,
    text: "Peer Reviewer Evaluation Approval ",
    securityKey: [admin],
  },
  {
    id: "batchCert",
    path: "/batchcert",
    exact: true,
    title: "Batch Certificates to Invoice",
    component: BatchCertPage,
    hasParams: false,
    text: "Batch Certificate",
    securityKey: [admin],
  },
  {
    id: "invoiceApproval",
    path: "/InvoiceApproval",
    exact: true,
    title: "Invoice Approval",
    component: InvoiceApproval,
    hasParams: false,
    text: "Invoice Approval",
    securityKey: [admin],
  },
  {
    id: "generateInvoice",
    path: "/GenerateInvoice",
    exact: true,
    title: "Generate Invoice",
    component: GenerateInvoice,
    hasParams: false,
    text: "Invoice Approval",
    securityKey: [admin],
  },
  {
    id: "certificateGroupingRequest",
    path: "/CertificateGroupingRequest",
    exact: true,
    title: "Certificate Grouping Request",
    component: CertificateGroupingRequest,
    hasParams: false,
    text: "Certificate Grouping Request",
    securityKey: [admin],
  },
  {
    id: "certificateGrouping",
    path: "/CertificateGrouping",
    exact: true,
    title: "Certificate Grouping",
    component: CertificateGrouping,
    hasParams: false,
    text: "Certificate Grouping",
    securityKey: [admin],
  },
  {
    id: "certificateGroupingApprove",
    path: "/CertificateGroupingApprove",
    exact: true,
    title: "Certificate Grouping Approve",
    component: CertificateGroupingApprove,
    hasParams: false,
    text: "Certificate Grouping Approve",
    securityKey: [admin],
  },
  {
    id: "XeroPaymentUpdateList",
    path: "/XeroPaymentUpdateList",
    exact: true,
    title: "Xero Payment Update List",
    component: XeroPaymentUpdateListPage,
    hasParams: false,
    text: "Xero Payment Update List",
    securityKey: [admin],
  },
  {
    id: "CertificateIssuance",
    path: "/CertificateIssuance",
    exact: true,
    title: "Certificate Issuance",
    component: CertificateIssuancePage,
    hasParams: false,
    text: "Certificate Issuance",
    securityKey: [admin],
  },
  {
    id: "CorporateMembershipReport",
    path: "/CorporateMembershipReport",
    exact: true,
    title: "Corporate Member Data Extraction",
    component: CorporateMembershipReport,
    hasParams: false,
    text: "Corporate Member Data Extraction",
    securityKey: [admin,lead],
  },
  {
    id: "MembershipAnalyticsByMonth",
    path: "/MembershipAnalyticsByMonth",
    exact: true,
    title: "Membership Analytics by Month",
    component: MembershipAnalyticsByMonth,
    hasParams: false,
    text: "Membership Analytics by Month",
    securityKey: [admin,lead],
  },
  {
    id: "MembershipAnalyticsByYear",
    path: "/MembershipAnalyticsByYear",
    exact: true,
    title: "Membership Analytics by Year",
    component: MembershipAnalyticsByYear,
    hasParams: false,
    text: "Membership Analytics by Year",
    securityKey: [admin,lead],
  },
  {
    id: "MemberOrganisationCategory",
    path: "/memberOrganisationCategory",
    exact: true,
    title: "Member Organisation Category",
    component: MemberOrganisationCategory,
    hasParams: false,
    text: "Member Organisation Category",
    securityKey: [admin,lead],
  },
  {
    id: "RenewalAnalytics",
    path: "/renewalAnalytics",
    exact: true,
    title: `Renewal Analytics ${new Date().getFullYear()}`,
    component: RenewalAnalyticsReport,
    hasParams: false,
    text: "Renewal Analytics",
    securityKey: [admin,lead],
  },
  {
    id: "MembershipRetentionRateReport",
    path: "/MembershipRetentionRateReport",
    exact: true,
    title: "Membership Retention Rate Report",
    component: MembershipRetentionRateReport,
    hasParams: false,
    text: "Membership Retention Rate Report",
    securityKey: [admin,lead],
  },
  {
    id: "membershipGrowthChart",
    path: "/membershipGrowthChart",
    exact: true,
    title: "Membership Growth Chart",
    component: MembershipGrowthChart,
    hasParams: false,
    text: "Membership Growth Chart",
    securityKey: [admin,lead],
  },
  {
    id: "membershipRetentionRateChart",
    path: "/membershipRetentionRateChart",
    exact: true,
    title: "Membership Retention Rate Chart",
    component: MembershipRetentionRateChart,
    hasParams: false,
    text: "Membership Retention Rate Chart",
    securityKey: [admin,lead],
  },
  // {
  //   id: "CertificateGroupingCommonForReview",
  //   path: "/CertificateGroupingCommonForReview/:id",
  //   exact: true,
  //   title: "Certificate Grouping (Common)",
  //   component: CertificateGroupingCommonForReview,
  //   hasParams: false,
  //   text: "Certificate Grouping (Common)",
  //   securityKey: [admin,lead],
  // },
  // {
  //   id: "CertificateGroupingGWPGeneralForReview",
  //   path: "/CertificateGroupingGWPGeneralForReview/:id",
  //   exact: true,
  //   title: "Certificate Grouping (GWP General)",
  //   component: CertificateGroupingGWPGeneralForReview,
  //   hasParams: false,
  //   text: "Certificate Grouping (GWP General)",
  //   securityKey: [admin,lead],
  // },
  // {
  //   id: "CertificateGroupingCommonForFinalReview",
  //   path: "/CertificateGroupingCommonForFinalReview/:id",
  //   exact: true,
  //   title: "Certificate Grouping (Common)",
  //   component: CertificateGroupingCommonForFinalReview,
  //   hasParams: false,
  //   text: "Certificate Grouping (Common)",
  //   securityKey: [admin,lead],
  // },

  // {
  //   id: "CertificateGroupingGWPGeneralForFinalReview",
  //   path: "/CertificateGroupingGWPGeneralForFinalReview/:id",
  //   exact: true,
  //   title: "Certificate Grouping (GWP General)",
  //   component: CertificateGroupingGWPGeneralForFinalReviewPage,
  //   hasParams: false,
  //   text: "Certificate Grouping (GWP General)",
  //   securityKey: [admin],
  // },
  // {
  //   id: "CertificateGroupingGWPConcreteForReview",
  //   path: "/CertificateGroupingGWPConcreteForReview/:id",
  //   exact: true,
  //   title: "Certificate Grouping (GWP Concrete)",
  //   component: CertificateGroupingGWPConcreteForReview,
  //   hasParams: false,
  //   text: "Certificate Grouping (GWP Concrete)",
  //   securityKey: [admin],
  // },
  // {
  //   id: "CertificateGroupingGWPConcreteForFinalReview",
  //   path: "/CertificateGroupingGWPConcreteForFinalReview/:id",
  //   exact: true,
  //   title: "Certificate Grouping (GWP Concrete)",
  //   component: CertificateGroupingGWPConcreteForFinalReview,
  //   hasParams: false,
  //   text: "Certificate Grouping (GWP Concrete)",
  //   securityKey: [admin],
  // },
  // {
  //   id: "CertificateGroupingTVOCForReview",
  //   path: "/CertificateGroupingTVOCForReview/:id",
  //   exact: true,
  //   title: "Certificate Grouping (TVOC)",
  //   component: CertificateGroupingTVOCForReview,
  //   hasParams: false,
  //   text: "Certificate Grouping (TVOC)",
  //   securityKey: [admin],
  // },
  // {
  //   id: "CertificateGroupingListTVOCFinalReview",
  //   path: "/CertificateGroupingListTVOCFinalReview/:id",
  //   exact: true,
  //   title: "Certificate Grouping (TVOC)",
  //   component: CertificateGroupingListTVOCFinalReview,
  //   hasParams: false,
  //   text: "Certificate Grouping (TVOC)",
  //   securityKey: [admin],
  // },
];
